import m from 'mithril'
import stream from 'mithril/stream'
import classNames from 'classnames'
import Liker from '../models/liker'


class LikersForm {
    constructor(vnode) {
        // window.house = (localStorage.getItem("liker") != null) ? JSON.parse(localStorage.getItem("liker")) : []
        this.houseId = parseInt(vnode.attrs.id)
    }
    view(vnode) {
        return (window.IsAuthenticated == "True") ? [m("a.heart-icon", {
                "id": "house-" + this.houseId,
                "data-bind": this.houseId,
                "tabindex": "0",
                class: classNames({
                    "loved": window.house.includes(this.houseId)
                }),
                onclick: (e) => {
                    if (window.house.indexOf(this.houseId) > -1) {
                        window.house.splice(window.house.indexOf(this.houseId), 1)
                    } else {
                        window.house.push(this.houseId)
                    }
                    Liker.save(window.house)
                    // localStorage.setItem("liker", JSON.stringify(window.house))
                }
            },
        )]: [m("a.heart-icon", {
                    "id": "house-" + this.houseId,
                    "data-bind": this.houseId,
                    "tabindex": "0",
                    "data-target": "#logonModal",
                    "data-url": window.loginUrl,
                    onclick: (e) => {
                        window.LoginModal()
                    }
                },
                m("span",
                    "liker"
                )
            )

        ]

    }
}


export default LikersForm